export class UserModel {
    id: number;
    firstName: string | null | '';
    fullName: string;
    lastName: string | null | '';
    email: string | null | '';
    status: number;

    constructor () {
        this.id = 0;
        this.firstName = null;
        this.fullName = '';
        this.lastName = null;
        this.email = null;
        this.status = 0;
    }

    public static fromJson (json: any): UserModel {
        const toTitleCase = (str:string) => 
            str.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
        const user = new UserModel;
        Object.assign(user, {
            id: json.id,
            firstName: json.first_name,
            fullName: toTitleCase(json.first_name + ' ' + json?.last_name),
            lastName: json.last_name,
            email: json.email,
            status: json.status,
            roleIds: json.roles
        });
        return user;
    }
}